/*!
 * Copyright © 2026 Nail Alliance - North America, Inc.
 * Authors: See snippets/copyright-notices.liquid in the theme.
 * No other use is authorized without a written contract.
 */

if (!customElements.get('page-content-router')) {
  class PageContentRouter extends HTMLElement {
    connectedCallback() {
      const content = this.querySelector('[data-page-content]');
      const navigation = this.querySelector('[data-page-context-nav]');
      if (!content || !navigation) return;

      const expectedHeadings = new Map([
        ['gelish', 'gelish'],
        ['polygel', 'polygel'],
        ['poly gel', 'polygel'],
        ['gelish dip', 'gelish-dip'],
      ]);
      const availableTargets = new Set();

      content.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((heading) => {
        const normalizedText = heading.textContent.trim().toLowerCase().replace(/\s+/g, ' ');
        const targetId = expectedHeadings.get(normalizedText);

        if (!targetId) return;
        if (!heading.id) heading.id = targetId;
        availableTargets.add(targetId);
      });

      this.querySelectorAll('[data-page-jump]').forEach((link) => {
        link.hidden = !availableTargets.has(link.dataset.pageJump);
      });

      navigation.hidden = availableTargets.size === 0;
    }
  }

  customElements.define('page-content-router', PageContentRouter);
}
